import { useSnapshot } from "valtio"
import { configStore, loginStore } from "../state/CommonState"
import { enquiryStorev2 } from "./enquiry-data-v2"

export default function EnquiryConfirmationv2(props) {
    useSnapshot(configStore)
    useSnapshot(enquiryStorev2)
    let modalClass = 'modal'
    if (configStore.enquiryModalVisible) modalClass += ' is-active'
    // console.log(enquiryStorev2.current)
    
    return (
        <div className={modalClass}>
            <div className="modal-background"></div>
            <div className="modal-card">
                <section className="modal-card-head" style={{textAlign: 'left', fontSize: '1.4rem', fontWeight: 'bold'}}>
                    <span style={{width:'90%'}}>Enquiry Confirmation</span>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => {
                           
                            // configStore.homescreenCurrentView = 'list'
                            
                            enquiryStorev2.initialize();
                            enquiryStorev2.currentCargoTableKey = "" + new Date().getMilliseconds();
                            enquiryStorev2.current.createdBy = loginStore.email;
                            enquiryStorev2.current.gst = configStore.currentSelectedEntity.gst;
                            enquiryStorev2.current.shipmentType =
                              configStore.homescreenCurrentShipmentType;
                            configStore.homescreenCurrentView = "new";
                            configStore.scheduleOrCarrierform = "schedule";
                            configStore.enquiryModalVisible = false
                           
                        }}>
                        </button>
                </section>
                
                <section className="modal-card-body" style={{ textAlign: 'center', fontSize: '1.3rem' }}>
                    <div>Thank you for your enquiry. We will work on it and share the quotation on priority. 
                        Please await a notification from our end on your registered Email ID</div>
                    <div>We appreciate your patience.</div>
                    <div>Team {process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE}</div>
                   <h2>Enquiry Number:{configStore.enquiryModalNum}</h2>
                </section>
            </div>
        </div>
    )
}